<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit State Holiday
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
         <v-row>
            <v-col sm="4">
               <v-autocomplete
                ref="state"
                outlined
                v-model="form.state"
                :items="stateItems"
                label="State *"
                hint="State for which this holiday is applicable"
                clearable
                :error-messages="errors.state"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-menu
                  v-model="holidayDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.holiday_date"
                        label="Holiday Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        hide-details="auto"
                        clearable
                        @click:clear="(form.holiday_date = null)"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.holiday_date"
                      @input="holidayDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.description"
                outlined
                label="Description"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'state_holidays'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update State Holiday
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "StateHolidayEditPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      stateItems: [],
      isLoading: false,
      isFetching: false,
      holidayDateMenu: false,
      isMasterLoading: false,
    };
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getMasters();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getMasters() {
      this.isMasterLoading = true;
      await axios
        .get(`masters?context=state_holidays`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.states.forEach((state) => {
            this.stateItems.push({
              id: state.id,
              text: state.description,
              value: state.description,
            });
          });
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isMasterLoading = false;
      this.getData();
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.stateHolidayId;
      axios
        .get(`/state_holidays/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.form.holiday_date = this.form.holiday_date ? this.form.holiday_date.substring(0, 10) : null;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios
          .patch(`/state_holidays/${this.$route.params.stateHolidayId}`, this.form)
          .then(async () => {
            await this.saveUserTimestamp(this.old_json, this.form);
            this.$router.push("/state-holidays");
          })
          .catch((error) => {
            console.error(error);
            this.isUnAuthorised();
          });
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
